// extracted by mini-css-extract-plugin
module.exports = {"page":"_clMiOeHL","error_block":"_I9cYQET2","text":"_4OWiO4bb"};